import { render, staticRenderFns } from "./employment-contract-item.vue?vue&type=template&id=50dcbc4c&scoped=true"
import script from "./employment-contract-item.vue?vue&type=script&lang=js"
export * from "./employment-contract-item.vue?vue&type=script&lang=js"
import style0 from "./employment-contract-item.vue?vue&type=style&index=0&id=50dcbc4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcbc4c",
  null
  
)

export default component.exports